import { render, staticRenderFns } from "./GuppyChatSendVoiceMessage.vue?vue&type=template&id=351723bb&"
import script from "./GuppyChatSendVoiceMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSendVoiceMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports